"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        this.size = 4;
        this.score = 0;
        this.gameStatus = "idle";
        this.board = initialState || this.createEmptyBoard();
    }
    createEmptyBoard() {
        return Array.from({
            length: this.size
        }, ()=>Array(this.size).fill(0));
    }
    moveLeft() {
        const changed = this.handleMove(this.board, false);
        if (changed) {
            this.addRandomTile();
            this.checkGameOver();
        }
    }
    moveRight() {
        const changed = this.handleMove(this.board, true);
        if (changed) {
            this.addRandomTile();
            this.checkGameOver();
        }
    }
    moveUp() {
        const transposed = this.transpose(this.board);
        const changed = this.handleMove(transposed, false);
        if (changed) {
            this.board = this.transpose(transposed);
            this.addRandomTile();
            this.checkGameOver();
        }
    }
    moveDown() {
        const transposed = this.transpose(this.board);
        const changed = this.handleMove(transposed, true);
        if (changed) {
            this.board = this.transpose(transposed);
            this.addRandomTile();
            this.checkGameOver();
        }
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.board;
    }
    getStatus() {
        return this.gameStatus;
    }
    start() {
        if (this.gameStatus === "idle") {
            this.gameStatus = "playing";
            this.board = this.createEmptyBoard();
            this.addRandomTile();
            this.addRandomTile();
        }
    }
    restart() {
        this.score = 0;
        this.gameStatus = "idle";
        this.start();
    }
    handleMove(grid, reverse) {
        let changed = false;
        for(let i = 0; i < this.size; i++){
            const row = [
                ...grid[i]
            ];
            if (reverse) row.reverse();
            const filtered = row.filter((v)=>v !== 0);
            for(let j = 0; j < filtered.length - 1; j++)if (filtered[j] === filtered[j + 1]) {
                filtered[j] *= 2;
                this.score += filtered[j];
                filtered[j + 1] = 0;
                if (filtered[j] === 2048) this.gameStatus = "win";
            }
            const merged = filtered.filter((v)=>v !== 0);
            const newRow = [
                ...merged,
                ...Array(this.size - merged.length).fill(0)
            ];
            if (reverse) newRow.reverse();
            if (!this.arraysEqual(newRow, grid[i])) {
                grid[i] = newRow;
                changed = true;
            }
        }
        return changed;
    }
    transpose(matrix) {
        return matrix[0].map((_, i)=>matrix.map((row)=>row[i]));
    }
    arraysEqual(a, b) {
        return a.every((val, i)=>val === b[i]);
    }
    addRandomTile() {
        const empty = [];
        for(let a = 0; a < this.size; a++){
            for(let b = 0; b < this.size; b++)if (this.board[a][b] === 0) empty.push([
                a,
                b
            ]);
        }
        if (!empty.length) return;
        const [i, j] = empty[Math.floor(Math.random() * empty.length)];
        this.board[i][j] = Math.random() < 0.9 ? 2 : 4;
    }
    checkGameOver() {
        if (this.board.some((row)=>row.includes(2048))) return;
        if (this.board.some((row)=>row.includes(0))) return;
        const directions = [
            this.moveLeftPreview,
            this.moveRightPreview,
            this.moveUpPreview,
            this.moveDownPreview
        ];
        if (directions.some((fn)=>fn.call(this))) return;
        this.gameStatus = "lose";
    }
    moveLeftPreview() {
        return this.board.some((row)=>{
            for(let i = 0; i < row.length - 1; i++){
                if (row[i] === row[i + 1]) return true;
            }
            return false;
        });
    }
    moveRightPreview() {
        return this.moveLeftPreview();
    }
    moveUpPreview() {
        const transposed = this.transpose(this.board);
        return transposed.some((row)=>{
            for(let i = 0; i < row.length - 1; i++){
                if (row[i] === row[i + 1]) return true;
            }
            return false;
        });
    }
    moveDownPreview() {
        return this.moveUpPreview();
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$cells = document.querySelectorAll(".field-cell");
const $09e991522ca7e64e$var$scoreElem = document.querySelector(".game-score");
const $09e991522ca7e64e$var$startBtn = document.querySelector(".button");
const $09e991522ca7e64e$var$msgStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$msgWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$msgLose = document.querySelector(".message-lose");
function $09e991522ca7e64e$var$renderBoard() {
    const state = $09e991522ca7e64e$var$game.getState().flat();
    $09e991522ca7e64e$var$cells.forEach((cell, idx)=>{
        const val = state[idx];
        cell.textContent = val === 0 ? "" : val;
        cell.className = "field-cell";
        if (val) cell.classList.add(`field-cell--${val}`);
    });
    $09e991522ca7e64e$var$scoreElem.textContent = $09e991522ca7e64e$var$game.getScore();
    $09e991522ca7e64e$var$updateMessages();
}
function $09e991522ca7e64e$var$updateMessages() {
    const gameStatus = $09e991522ca7e64e$var$game.getStatus();
    $09e991522ca7e64e$var$msgStart.classList.toggle("hidden", gameStatus !== "idle");
    $09e991522ca7e64e$var$msgWin.classList.toggle("hidden", gameStatus !== "win");
    $09e991522ca7e64e$var$msgLose.classList.toggle("hidden", gameStatus !== "lose");
    if (gameStatus === "playing") {
        $09e991522ca7e64e$var$startBtn.classList.replace("start", "restart");
        $09e991522ca7e64e$var$startBtn.textContent = "Restart";
    } else {
        $09e991522ca7e64e$var$startBtn.classList.replace("restart", "start");
        $09e991522ca7e64e$var$startBtn.textContent = "Start";
    }
}
$09e991522ca7e64e$var$startBtn.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "idle") $09e991522ca7e64e$var$game.start();
    else $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$renderBoard();
});
document.addEventListener("keydown", (e)=>{
    const key = e.key;
    switch(key){
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            break;
        default:
            return;
    }
    $09e991522ca7e64e$var$renderBoard();
});
$09e991522ca7e64e$var$renderBoard();


//# sourceMappingURL=index.318788d3.js.map
